// extracted by mini-css-extract-plugin
module.exports = {"container":"SectionProject1Template_container__O54Ro","sectionImageContainer":"SectionProject1Template_sectionImageContainer__WhA_C"};